export default __webpack_public_path__ + "static/card1-6e7da9fce954934f8130241161df79d9.png";